import axios from 'axios';


const httpClient = axios.create({
  baseURL: '',
  timeout: 300000,
  headers: {
    'current-language': localStorage.getItem('leanasst-language') ?? ''
  }
});

export default httpClient;
